module.exports = __webpack_public_path__ + "static/media/navprofile.ed0a0655.svg";